import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <section className="bg-white border-b border-slate-200 py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-[#0f1f2e] mb-4">Cookie Policy</h1>
          <p className="text-slate-500">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Card className="bg-white border-slate-200 shadow-sm">
            <CardContent className="p-8 md:p-12 prose prose-slate max-w-none">
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                This Cookie Policy explains how IpFunders uses cookies and similar technologies when you visit our website.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Cookies and Similar Technologies</h2>
              <p className="text-slate-600 leading-relaxed">
                This website may use cookies and similar technologies to enable basic functionality and collect anonymized usage statistics. Cookies are small text files stored on your device that help us understand how visitors interact with our site.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">How We Use Cookies</h2>
              <p className="text-slate-600 leading-relaxed">
                We use cookies to understand how visitors interact with our website and to improve its performance and user experience. The information collected is aggregated and anonymized.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Your Choices</h2>
              <p className="text-slate-600 leading-relaxed">
                You can control or disable cookies through your browser settings. Most browsers allow you to refuse cookies or alert you when cookies are being sent. Please note that disabling cookies may affect website functionality. Your continued use of this website constitutes consent to our use of cookies consistent with this policy.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicyPage;
